import { render, staticRenderFns } from "./Somos1ReportsHome.vue?vue&type=template&id=27b949ec&scoped=true"
import script from "./Somos1ReportsHome.vue?vue&type=script&lang=js"
export * from "./Somos1ReportsHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b949ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b949ec')) {
      api.createRecord('27b949ec', component.options)
    } else {
      api.reload('27b949ec', component.options)
    }
    module.hot.accept("./Somos1ReportsHome.vue?vue&type=template&id=27b949ec&scoped=true", function () {
      api.rerender('27b949ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/Somos1ReportsHome.vue"
export default component.exports